import { useMutation } from '@tanstack/react-query';
import type { CandidateProfileUpdateRequest } from '../types/CandidateProfile';

export default function useUpdateCandidateProfile() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({
      candidateProfileId,
      name,
      organization_user_ids,
      custom_data,
    }: CandidateProfileUpdateRequest) => {
      const response = await fetch(`/agent/api/candidate_profiles/${candidateProfileId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          id: candidateProfileId,
          name,
          organization_user_ids,
          custom_data,
        }),
      });

      // TODO: バックエンド側で SharedValidationError 型が生成されたら
      // `data: unknown` を `SharedValidationError` に差し替える
      const data = await response.json();

      // エラーレスポンスの場合は例外を投げる
      if (!response.ok) {
        // 新フォーマット { success: false, message: string, errors: string[] } を優先し、
        // 旧フォーマット { success: false, error: string } はフォールバックとして扱う
        let errorMessage = '';
        if (Array.isArray(data.errors) && data.errors.length > 0) {
          // 複数エラーを改行区切りで結合（表示側で \n を区切り文字に変換する）
          errorMessage = (data.errors as string[]).join('\n');
        } else if (typeof data.error === 'string' && data.error.length > 0) {
          errorMessage = data.error;
        }
        // いずれも存在しない場合のみ汎用メッセージを使用
        if (errorMessage === '') {
          errorMessage = '更新に失敗しました';
        }
        const error = new Error(errorMessage);
        (error as Error & { apiMessage?: string }).apiMessage = errorMessage;
        throw error;
      }

      return data;
    },
  });
}
